module.exports = __webpack_public_path__ + "img/Longueur-cheveux.2e4a99eb.jpeg";